import { render, staticRenderFns } from "./DisableTwoFactorAuth.vue?vue&type=template&id=f06212fa&scoped=true"
import script from "./DisableTwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./DisableTwoFactorAuth.vue?vue&type=script&lang=js"
import style0 from "./DisableTwoFactorAuth.vue?vue&type=style&index=0&id=f06212fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06212fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f06212fa')) {
      api.createRecord('f06212fa', component.options)
    } else {
      api.reload('f06212fa', component.options)
    }
    module.hot.accept("./DisableTwoFactorAuth.vue?vue&type=template&id=f06212fa&scoped=true", function () {
      api.rerender('f06212fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/user/DisableTwoFactorAuth.vue"
export default component.exports